import React from 'react'
import { useIntl } from 'react-intl'

import PriceLayout, { FeaturedPrice } from '../../../PriceLayout'
import { OfferPriceProps } from '..'

const OfferPriceGross = ({
  className,
  board,
  nights,
  priceData,
  prime = false,
  showDiscountBadge,
  showDiscount,
  showFrom,
  showSubtitle,
  loading = false,
}: OfferPriceProps) => {
  const intl = useIntl()

  const {
    currency,
    discount,
    pricePerNight,
    initialPrice,
    finalPrice,
    taxDetails,
    additionalFees,
    insuranceSelected,
  } = board

  return (
    <PriceLayout
      className={className}
      currency={currency}
      discount={discount}
      pricePerNight={pricePerNight}
      priceInitial={initialPrice}
      priceFinal={finalPrice}
      vats={intl.formatMessage({ id: 'global.vat-included' })}
      priceData={priceData}
      prime={prime}
      showDiscount={showDiscount}
      showDiscountBadge={showDiscountBadge}
      showFrom={showFrom}
      nights={nights}
      featuredPrice={FeaturedPrice.Total}
      loading={loading}
      showSubtitle={showSubtitle}
      taxDetails={taxDetails}
      additionalFees={additionalFees}
      insuranceSelected={insuranceSelected}
    />
  )
}

export default OfferPriceGross
